import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = (resource) => {
  return [
    <MenuItem primaryText='Edit' key='edit' value={`/write-now/homework/${resource.homework_id}/tasks/${resource.id}/edit`} />
  ]
}

export default buildMenuItems
